/**
 * Fetch an api endpoint, with provided Authorization header, for authentication.
 *
 * @param url the url to fetch
 * @param options options for fetch, array, or might be undefined.
 * @returns Promise for fetch
 */
export function fetchAPI(url :string, options: any = {}) : Promise<Response> {
  const user = localStorage.getItem("user") !== null ? JSON.parse(localStorage.getItem("user") as string) : null;
  const onecommConfigurations = window['onecommConfigurations' as any] as any
  
  const customHeaders = options && options.headers ? options.headers : {};

  let headers = {
    ...customHeaders,
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
  };

  if (user && user.access_token ){
    headers = {
      ...headers,
      'Authorization': 'Bearer ' + user.access_token,
      'x-api-key' : onecommConfigurations.REACT_APP_API_KEY
    }
  }

  let fetchOptions = {...options, headers};

  return fetch(onecommConfigurations.REACT_APP_URL_API + url, fetchOptions);
}